import { LoadingIcon } from 'bc-front-sagacomponents';
import { MuiThemeProvider, Theme } from '@material-ui/core';
import { ReactNode, useEffect, useState } from 'react';
import theme from '../../theme';
import { CompteParticulierResponse, PersonnalisationClient } from '../../services/Api/swagger';
import { createCustomTheme } from '../../themeCustom';
import { TypedUseSelectorHook, useSelector as useReduxSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { useLocation } from 'react-router-dom';
import { getPersonnalisationPart } from '../../redux/ReferentielRedux';
import { getCompteParticulier } from '../../redux/AdherentRedux';

interface Props {
  children: ReactNode;
  setTheme: (arg0: Theme) => void;
}

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

function CustomThemeProvider(props: Props) {
  const personnalisation = useSelector<PersonnalisationClient>((state) => getPersonnalisationPart(state));
  const compteUtilisateur = useSelector<CompteParticulierResponse | undefined>((state) => getCompteParticulier(state));

  const [themeUsed, setThemeUsed] = useState<Theme>(theme);

  const location = useLocation();

  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (personnalisation) {
      if (personnalisation.personnalisation?.theme) {
        setThemeUsed(createCustomTheme(personnalisation.personnalisation));
        props.setTheme(createCustomTheme(personnalisation.personnalisation));
      }
    }
    setLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personnalisation]);

  useEffect(() => {
    if (location.pathname === '/contact') {
      setLoaded(true);
    }
    setLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (location.pathname === '/') {
    return <MuiThemeProvider theme={theme}> {props.children}</MuiThemeProvider>;
  }
  if (!loaded) {
    // empeche le clignotement des bouton et svg
    return <LoadingIcon defaultColor={true} />;
  }
  if (!personnalisation) {
    return <MuiThemeProvider theme={theme}> {props.children}</MuiThemeProvider>;
  } else return <MuiThemeProvider theme={themeUsed}> {props.children}</MuiThemeProvider>;
}

export default CustomThemeProvider;
